import { useCallback, useEffect, useRef, useState } from "react";
import { usePlayerContext } from "../../utils/PlayerContext";
import { logW, logD } from "@blacknut/logging/dist";
import { LOGGING_TAG } from "../../utils/logging";
const useFullscreen = () => {
  const { fullscreen, requestKeyboardLock, preferedWindowMode } = usePlayerContext();
  useEffect(() => {
    const onFullscrenChange = async () => {
      if (fullscreen && preferedWindowMode !== "windowed") {
        logD(LOGGING_TAG, "Fullscreen ==> request keyboard lock");
        try {
          await requestKeyboardLock?.();
        } catch (e) {
          logW(LOGGING_TAG, "Caught error requesting keyboard lock", e);
        }
      } else {
        // TODO
      }
    };
    onFullscrenChange();
  }, [fullscreen]);
};
export default useFullscreen;
